import {ClassToValues, EmbeddedEditView, GridEventBusInfo, NamaWarning, WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";
import EditPlace from "@/utils/presenters/EditPlace.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import EditViewUtils from "@/utils/editView/EditViewUtils.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import {useErrorsStore, useMessagesStore} from "@/stores/ToastDataStore.ts";
import ClientCache from "@/utils/login/ClientCache.ts";
import Translator from "@/utils/common/Translator.ts";
import NamaCommon, {NamaAxiosRequestConfig} from "@/utils/common/NamaCommon.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";
import ViewMode from "@/utils/constants/ViewMode.ts";
import DomainBaseEntities from "@/utils/constants/DomainBaseEntities.ts";
import RouteNames from "@/router/RouteNames.ts";
import router from "@/router";
import {computed, type ComputedRef, Ref, ref, toRaw, triggerRef, watch} from 'vue';
import BaseDispatcher from "@/utils/presenters/BaseDispatcher.ts";
import EditViewToolbarUtils from "@/utils/editView/EditViewToolbarUtils.ts";
import ActionHandler from "@/utils/moreMenu/ActionHandler.ts";
import SecurityUtils from "@/utils/login/SecurityUtils.ts";
import EditViewPerformer from "@/utils/presenters/EditViewPerformer.ts";
import SaveBehavior from "@/utils/constants/SaveBehavior.ts";
import MetaData from "@/utils/common/MetaData.ts";
import {AxiosRequestConfig} from "axios";
import EntityTypesUtils from "@/utils/common/EntityTypesUtils.ts";
import DomainBaseFieldIDs from "@/utils/constants/DomainBaseFieldIDs.ts";
import LoginUtils from "@/utils/login/LoginUtils.ts";
import OutputFormat from "@/utils/constants/OutputFormat.ts";
import CacheUtil from "@/utils/login/CacheUtil.ts";
import {QuestionFieldsSerializer} from "@/utils/urlUtils/CriteriaAndQuestionsURLParser.ts";
import PrintingOption from "@/utils/constants/PrintingOption.ts";
import NamaPrinting from "@/utils/common/NamaPrinting.ts";
import NaMaConfirmationDialog from "@/utils/forms/NaMaConfirmationDialog.ts";
import NavigationType from "@/utils/constants/NavigationType.ts";
import ListPlace from "@/utils/presenters/ListPlace.ts";
import FieldType from "@/utils/constants/FieldType.ts";
import GUIUtilities from "@/utils/common/GUIUtilities.ts";
import BSCEntities from "@/utils/constants/BSCEntities.ts";
import MoreMenuItem, {SimpleEntityMenuItem} from "@/utils/UIConstants/MoreMenuItem.ts";
import CommonConstants from "@/utils/constants/CommonConstants.ts";
import EntitiesWithLedgerEffectsOrWithParents from "@/utils/constants/EntitiesWithLedgerEffectsOrWithParents.ts";
import CriteriaBuilder from "@/utils/criteria/CriteriaBuilder.ts";
import IdsAndConstants from "@/utils/UIConstants/IdsAndConstants.ts";
import SimpleEntities from "@/utils/constants/SimpleEntities.ts";
import FAEntities from "@/utils/constants/FAEntities.ts";
import CapabilityType from "@/utils/constants/CapabilityType.ts";
import ActionPerformerUtil from "@/utils/moreMenu/ActionPerformerUtil.ts";
import DialogHandler, {CommonDialogAction} from "@/utils/forms/DialogHandler.ts";
import ListViewUtils from "@/utils/common/ListViewUtils.ts";
import {QuestionFieldsPresenter} from "@/utils/presenters/QuestionFieldsPresenter.ts";
import {WatchStopHandle} from "@vue/runtime-core";
import NamaPlace from "@/utils/presenters/NamaPlace.ts";
import RepOutputFormat from "@/utils/constants/RepOutputFormat.ts";
import ReportViewerPresenter, {EmailSenderDialogType} from "@/utils/presenters/ReportViewerPresenter.ts";
import DownloadPurpose from "@/utils/constants/DownloadPurpose.ts";
import WidgetState from "@/utils/constants/WidgetState.ts";
import ApplicableWhen from "@/utils/constants/ApplicableWhen.ts";
import GenerationType from "@/utils/constants/GenerationType.ts";
import TreeViewPresenter from "@/utils/presenters/TreeViewPresenter.ts";
import HierarchyFilterHelper from "@/utils/common/HierarchyFilterHelper.ts";
import TreeModelProvider from "@/utils/common/TreeModelProvider.ts";
import CommonEntityViewCustomizer from "@/utils/UIConstants/CommonEntityViewCustomizer.ts";
import FieldToFocusUtils from "@/utils/common/FieldToFocusUtils.ts";
import FieldValuesSetter from "@/utils/presenters/FieldValuesSetter.ts";
import {useToastManager} from "@/stores/ToastsComposable.ts";
import DocumentFileStatus from "@/utils/constants/DocumentFileStatus.ts";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import {LocationQuery, RouteLocationNamedRaw, RouteRecordNameGeneric} from "vue-router";
import QuickFilterUtils from "@/utils/common/QuickFilterUtils.ts";
import NotificationUtils from "@/utils/broadcast/NotificationUtils.ts";
import EditScreenLayout = namaTypes.EditScreenLayout;
import BaseEntityDTO = namaTypes.BaseEntityDTO;
import NaMaMetaData = namaTypes.NaMaMetaData;
import GUIActionPlaceholder = namaTypes.GUIActionPlaceholder;
import EditScreenField = namaTypes.EditScreenField;
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;
import DTOMenuItem = namaTypes.DTOMenuItem;
import DTOGui2Response = namaTypes.DTOGui2Response;
import CompositeEditScreenField = namaTypes.CompositeEditScreenField;
import DTOConfirmation = namaTypes.DTOConfirmation;
import EditScreenPage = namaTypes.EditScreenPage;
import UIPreferences = namaTypes.UIPreferences;
import DTOFilledQuestionField = namaTypes.DTOFilledQuestionField;
import DTOCriteria = namaTypes.DTOCriteria;
import DTOMenuDefinition = namaTypes.DTOMenuDefinition;
import NavigationRequest = namaTypes.NavigationRequest;
import NaMaError = namaTypes.NaMaError;
import PrintReportRequest = namaTypes.PrintReportRequest;
import NaMaText = namaTypes.NaMaText;
import FieldMetaData = namaTypes.FieldMetaData;
import GCFailure = namaTypes.GCFailure;
import QuestionField = namaTypes.QuestionField;
import DTOSimpleEntityRef = namaTypes.DTOSimpleEntityRef;
import MatchingSimpleEntityParam = namaTypes.MatchingSimpleEntityParam;
import GUIActionResult = namaTypes.GUIActionResult;
import EntityReferenceData = namaTypes.EntityReferenceData;
import ChangeCapabilitiesRequest = namaTypes.ChangeCapabilitiesRequest;
import FieldActionContextInfo = namaTypes.FieldActionContextInfo;
import LaunchReportRequest = namaTypes.LaunchReportRequest;
import DTOEmailSendRequest = namaTypes.DTOEmailSendRequest;
import EntityMainFileInfo = namaTypes.EntityMainFileInfo;
import PrintingParams = namaTypes.PrintingParams;

export class EditPresenter implements WidgetsPresenter {
  layoutPages: EditScreenPage[] = [];
  extraLayoutPages: EditScreenPage[] = [];
  pages = ref<EditScreenPage[]>([]);
  visibleHeaderFields: (EditScreenField | GUIActionPlaceholder)[] = [];
  visibleGridColumns: EditScreenGridColumn[] = [];
  gridHandlers: Record<string, EditableGridHandler> = {};
  record: Ref<BaseEntityDTO | undefined> = ref();
  private _rawRecord: Record<string, any> | undefined | null = null;
  approvalEditableFields = computed(() => {
    if (!this.record.value?.currentApprovalCase?.allowEditingFields)
      return [];
    return this.record.value.currentApprovalCase.allowEditingFields.split(",");
  })
  private gridSelectedLines: Ref<Record<string, number>> = ref({});
  createdObject: BaseEntityDTO | undefined;
  metadata?: NaMaMetaData;
  layout?: EditScreenLayout;
  place: EditPlace;
  dispatcher?: BaseDispatcher;
  clone?: BaseEntityDTO;
  afterDeleteRecord?: DTOGui2Response | null = null;
  doNotHideErrors?: boolean;
  doNotHideWarnings?: boolean;
  skipNextRouteRefresh: boolean = false;
  parentFieldTitle: string = '';
  headerErrors: Ref<ErrorsHolder> = ref(new ErrorsHolder());
  detailErrors: Ref<ErrorsHolder> = ref(new ErrorsHolder());
  treeView?: TreeViewPresenter;
  embeddedEditViewList: EditPresenter[] = [];
  editScreenEmbeddedEditView?: EmbeddedEditView | null = null;
  afterFetchListener?: (object: BaseEntityDTO) => void;
  gridEventBus: Ref<(Record<string, GridEventBusInfo>)> = ref({});
  private _codeSateLiteFieldIds: string[] = [];
  private _forceDirty?: boolean;
  private _validLayout: Ref<boolean> = ref(true);
  recordLoaded: Ref<boolean> = ref(false);
  private _templateFieldCallerName?: string;
  private _templateFieldCallerValue?: any;
  private _serverDependentMenuItems?: MoreMenuItem[];
  public shortcutsHandler?: (businessFunctions: string[]) => Promise<boolean>;
  private watchers: WatchStopHandle[] = [];
  public closeQuickEditDialog?: () => void;
  public isBulkUpdating: boolean = false;
  private static idCounter = 1;
  public presenterId: number;

  constructor(place: EditPlace, shortcutsHandler?: (businessFunctions: string[]) => Promise<boolean>) {
    this.place = place;
    this.shortcutsHandler = shortcutsHandler;
    this.presenterId = EditPresenter.idCounter++;
  }

  get serverDependentMenuItems(): MoreMenuItem[] | undefined {
    return this._serverDependentMenuItems;
  }

  set serverDependentMenuItems(value: MoreMenuItem[]) {
    this._serverDependentMenuItems = value;
  }

  get codeSateLiteFieldIds(): string[] {
    return this._codeSateLiteFieldIds;
  }

  get validLayout(): Ref<boolean> {
    return this._validLayout;
  }

  addGridToGridEventBus(gridId: string) {
    this.gridEventBus.value[gridId] = {moveToNextRow: 0};
  }

  registerGridHandler(handler: EditableGridHandler) {
    this.gridHandlers[handler.gridId] = handler;
  }

  unregisterGridHandler(gridId: string) {
    delete this.gridHandlers[gridId];
  }

  listVisibleGridColumns(): EditScreenGridColumn[] {
    const handlers = Object.values(this.gridHandlers);
    if (!handlers.length)
      return this.visibleGridColumns;
    return handlers.flatMap(handler => handler.listCurrentlyVisibleColumns());
  }

  appendRow(fieldId?: string) {
    let gridId = MetaData.getFieldParentDetail(this.fetchMetadata(), fieldId)
    if (gridId) {
      if (!useNamaFlagsStore().doNotFocusColumn) {
        this.gridEventBus.value[gridId] = this.gridEventBus.value[gridId] || {};
        this.gridEventBus.value[gridId].moveToNextRow = this.gridEventBus.value[gridId].moveToNextRow ? this.gridEventBus.value[gridId].moveToNextRow + 1 : 1;
        this.gridEventBus.value[gridId].focusedCellId = fieldId?.substring(gridId.length + 1);
      }
    }
  }

  updateGridSelectedLine(gridId: string, lineNumber: number) {
    this.gridSelectedLines.value[gridId] = lineNumber;
  }

  refreshGridCells(gridId: string, columns?: string[]) {
    let info = this.gridEventBus.value[gridId] = this.gridEventBus.value[gridId] || {};
    info.refreshCells = {nonce: (info.refreshCells?.nonce ?? 0) + 1, columns};
  }

  fetchGridSelectedLine(gridId: string) {
    let lineNumber = this.gridSelectedLines.value[gridId];
    return lineNumber ?? 0;
  }

  get entityType(): string {
    return this.metadata?.owner?.ownerId || this.place.entityType!;
  }

  getDefaultCriteria(fieldId?: string): DTOCriteria | undefined {
    return undefined;
  }

  fetchNodeIdFromPlace(): string | undefined {
    return this.place.id;
  }

  setTreeView(treeViewPresenter: TreeViewPresenter): void {
    this.treeView = treeViewPresenter;
  }

  async onTreeNodeSelection() {
    if (!this.treeView)
      return;
    let selectedNodeId: string | null | undefined = this.treeView?.selectedNodeId.value;
    if (!selectedNodeId || selectedNodeId === this.place.id)
      return;
    this.place.id = selectedNodeId;
    if (this.place.view === ViewMode.NEW)
      this.place.view = ViewMode.EDIT;
    await this.edit(true);
    await this.updateRouterFromPlaceAndSkipNextRouteRefreshAndQuickCreator();
  }

  updateSelectedNodeId(value: string | undefined | null): void {
    if (this.treeView) {
      this.treeView.selectedNodeId.value = value;
      this.treeView.nodeSelectionEvent();
    }
  }

  getHelperForTreeView(): HierarchyFilterHelper | undefined {
    return CommonEntityViewCustomizer.getHelperForEditView(this.entityType);
  }

  getTreeModelProviderForTreeView(): TreeModelProvider | undefined {
    if (!NamaCommon.hasParentEntity(this.entityType))
      return undefined;
    return new TreeModelProvider(this.entityType);
  }

  fetchDispatcher(): BaseDispatcher {
    return this.dispatcher!;
  }

  fetchQuestionFields(): QuestionField[] {
    return [];
  }

  fetchMetadata(): NaMaMetaData {
    return this.metadata ?? {};
  }

  createSearchContextInfo(fieldId: string, lineNumber?: number): FieldActionContextInfo {
    return this.fetchDispatcher().createSearchContextInfo(fieldId, lineNumber);
  }

  fetchPlace(): NamaPlace {
    return this.place;
  }

  fetchFieldErrorMsg(fieldId: string): string {
    return this.headerErrors.value[fieldId];
  }

  fetchRecord(): Record<string, any> {
    return this._rawRecord ?? this.record.value!;
  }

  beginBulkUpdate() {
    this.isBulkUpdating = true;
    this._rawRecord = toRaw(this.record.value);
  }

  endBulkUpdate() {
    this._rawRecord = null;
    this.isBulkUpdating = false;
    triggerRef(this.record);
  }

  get templateFieldCallerName(): string | undefined {
    return this._templateFieldCallerName;
  }

  set templateFieldCallerName(value: string) {
    this._templateFieldCallerName = value;
  }

  get templateFieldCallerValue(): any {
    return this._templateFieldCallerValue;
  }

  set templateFieldCallerValue(value: any) {
    this._templateFieldCallerValue = value;
  }

  forceDirty() {
    this._forceDirty = true;
  }

  unForceDirty() {
    this._forceDirty = false;
  }

  isForceDirty(): boolean {
    return this._forceDirty ?? false;
  }

  async start() {
    if (ObjectChecker.isEmptyOrNull(this.place.entityType)) {
      useErrorsStore().pushErrorStr(Translator.translateLayoutId("badURL"));
      this._validLayout.value = false;
      return;
    }
    this._codeSateLiteFieldIds = EditViewUtils.getCodeSateLiteFieldIds(this.place.entityType);
    let preferences: UIPreferences = await EditViewUtils.fetchLayoutPreferences(this.place);
    this.metadata = preferences.metaData;
    this.layout = preferences.editLayout;
    await this.init();
  }

  async init() {
    this.dispatcher = new BaseDispatcher(this);
    await this.appendLayoutPagesToView();
    if (!this._validLayout)
      return;
    // TODO:: addEventListeners();
    const edited = await this.edit(true);
    const route: RouteLocationNamedRaw = {
      name: RouteNames.EDIT_VIEW_ROUTE as RouteRecordNameGeneric,
      query: this.place.fetchQuery() as LocationQuery
    };
    if (edited) {
      let title = Translator.getName(this.record.value ? this.record.value['name1'] : undefined, this.record.value ? this.record.value['name2'] : undefined);
      if (!title.length)
        title = this.getEditViewTitle().value;
      GUIUtilities.updateRecentVisits(route, title)
    } else
      GUIUtilities.deleteRecentVisit(route)
  }

  async appendLayoutPagesToView() {
    let layout = this.layout;
    if (!layout || !layout.pages || !layout.pages.length) {
      useErrorsStore().pushErrorStr("No valid layouts found - entity (" + this.entityType + ")");
      this._validLayout.value = false;
      return;
    }
    this.layoutPages = [];
    this.addLayoutPages(this.layoutPages, layout);
    this.pages.value = this.layoutPages;
    EditViewUtils.addTimelinePageForApprovalCase(this);
    if (!this.pages.value.length) {
      useErrorsStore().pushErrorStr("The current user can not view any pages in the entity " + this.entityType);
      this._validLayout.value = false;
    }
    this.watchForDocTermAndConfigEntryLayoutPages();
  }

  private watchForDocTermAndConfigEntryLayoutPages() {
    let isDocTerm = this.entityType === "DocumentTerm";
    let isConfigEntry = this.entityType === "ConfigEntry";
    if (!(isDocTerm || isConfigEntry))
      return;
    let w = watch(() => NamaCommon.getFieldValue(this.record.value, "documentType") + "" + NamaCommon.getFieldValue(this.record.value, "propertyName"),
      async (v) => {
      if (!this.record.value) {
        this.pages.value = this.layoutPages;
        return;
      }
      this.extraLayoutPages = [];
      let screenLayout: namaTypes.EditScreenLayout | null | undefined = null;
      if (isDocTerm)
        screenLayout = await CacheUtil.fetchTermScreen(this.record.value["documentType"]);
      else if (isConfigEntry)
        screenLayout = await CacheUtil.fetchConfigEntryScreen(this.record.value["propertyName"]);
      if (screenLayout)
        this.addLayoutPages(this.extraLayoutPages, screenLayout);
      this.pages.value = [...this.layoutPages, ...this.extraLayoutPages];
    })
    this.watchers.push(w);
  }

  private addLayoutPages(pages: EditScreenPage[], layout: namaTypes.EditScreenLayout) {
    if (!layout.pages || !layout.pages.length)
      return;
    for (let i = 0; i < layout.pages.length; i++) {
      let page: EditScreenPage = layout.pages[i] ?? {};
      if (EditViewUtils.isPageHidden(page, this.entityType, i))
        continue;
      pages.push(page);
    }
  }

  async viewVersion(version: number | undefined) {
    if (!await this.confirmNavigateAway())
      return;
    this.place.version = version;
    await this.updateRouterFromPlaceAndSkipNextRouteRefreshAndQuickCreator()
    await this.edit(false);
  }

  async showSpecificVersionDialog() {
    let okBtn: CommonDialogAction = CommonDialogAction.createOkDialogAction(async (record: Record<string, any>) => {
      await this.viewVersion(record['sepecificVersion']);
    });
    let cancelBtn: CommonDialogAction = CommonDialogAction.createCancelDialogAction(() => {
    });
    let questionField: QuestionField = NamaCommon.createQuestionField('sepecificVersion', FieldType.Integer);
    let dialogBox = new DialogHandler([okBtn, cancelBtn], Translator.translateId("select"), true);
    await dialogBox.createPresenter(this as WidgetsPresenter, [questionField]);
    await dialogBox.runDialogBox();
  }

  async edit(callConfirm: boolean): Promise<boolean | void> {
    if (callConfirm) {
      if (this.templateFieldCallerName) {
        if (this.clone && !this.clone[this.templateFieldCallerName])
          this.clone[this.templateFieldCallerName] = null;
        if (!await this.confirmNavigateAway(this.templateFieldCallerName))
          return false;
      } else if (!await this.confirmNavigateAway()) {
        return false;
      }
    }
    let createdObject: BaseEntityDTO | null = null;
    if (this.createdObject) {
      createdObject = this.createdObject;
    } else if (this.place.createdObjectId) {
      let item = localStorage.getItem(this.place.createdObjectId);
      if (item)
        createdObject = JSON.parse(item);
      localStorage.removeItem(this.place.createdObjectId);
      this.place.createdObjectId = undefined;
    }
    if (EditViewUtils.isNew(this.place) && ObjectChecker.isEmptyOrNull(this.place.id)) {
      if (createdObject && ObjectChecker.areEqual(createdObject.entityType, this.place.entityType)) {
        await this.doEdit(createdObject, "", this.place.view);
      } else { // TODO::
        let settings: AxiosRequestConfig = {
          params: {
            entityType: this.place.entityType,
            templateId: this.place.templateId,
            menuCode: this.place.src,
            viewName: this.place.calcEditViewName(),
            containerObjectEntityType: this.fetchContainerRecord()?.entityType,
            objectInitializationFieldMap: this.fetchObjectInitializationFieldMap()
          },
          data: {
            record: this.fetchRecord(),
            containerObjectForEmbeddedEdit: this.fetchContainerRecord(),
            context: this.place.quickCreateContextInfo
          }
        };
        let result = await NamaCommon.namaFetch(NamaURLS.CREATE_NEW, settings);
        if (result && NamaCommon.isSuccess(result))
          await this.doEdit(result.data, result.focusField, ViewMode.NEW);
      }
    } else if (createdObject) {
      await this.doEdit(createdObject, "", this.place.view);
      if (!this.place.id)
        this.place.view = ViewMode.NEW;
    } else if (ObjectChecker.isAnyEqualToFirst(this.place.view, ViewMode.EDIT, ViewMode.VIEW)
      && (ObjectChecker.isNotEmptyOrNull(this.place.id) || ObjectChecker.isNotEmptyOrNull(this.place.code))) {
      if (this.place.reNavigateToObject) {
        let reNavigateToObject: BaseEntityDTO = this.place.reNavigateToObject;
        this.place.reNavigateToObject = undefined;
        await this.doEdit(reNavigateToObject, "", this.place.view);
      } else {
        let idOrCode = ObjectChecker.isNotEmptyOrNull(this.place.id) ? this.place.id : this.place.code;
        let result = await NamaCommon.namaFetch(NamaURLS.FIND_BY_ID, {
          params: {
            entityType: this.place.entityType,
            id: idOrCode,
            findDraft: true,
            version: this.place.version
          }
        });
        if (result && NamaCommon.isSuccess(result))
          await this.doEdit(result.data, "", this.place.view);
        else
          return false;
      }
    } else {
      useErrorsStore().pushErrorStr("No View Selected");
      this._validLayout.value = false;
    }
    return true;
  }

  fetchContainerRecord(): BaseEntityDTO | undefined {
    if (!this.editScreenEmbeddedEditView || !this.editScreenEmbeddedEditView.block.objectInitializationFieldMap)
      return;
    if (this.editScreenEmbeddedEditView.fetchContainerObject)
      return this.editScreenEmbeddedEditView.fetchContainerObject();
    return;
  }

  fetchObjectInitializationFieldMap(): string | undefined {
    if (!this.editScreenEmbeddedEditView || !this.editScreenEmbeddedEditView.block.objectInitializationFieldMap)
      return;
    return this.editScreenEmbeddedEditView.block.objectInitializationFieldMap;
  }

  async doEdit(result: BaseEntityDTO, focusField: string | undefined, viewMode: string | undefined) {
    this.serverDependentMenuItems = [];
    this.unForceDirty();
    this.clearErrors();
    this.place.view = viewMode;
    if (result && EditViewUtils.isNew(this.place) && this.place.quickCreateRequester) {
      if (ObjectChecker.isAnyEqualToFirst(this.place.entityType, DomainBaseEntities.DocumentBook, DomainBaseEntities.DocumentTerm)
        && ObjectChecker.isEmptyOrNull(result['documentType'])) {
        result['documentType'] = this.place.quickCreateRequester;
      } else if (ObjectChecker.isAnyEqualToFirst(this.place.entityType, DomainBaseEntities.MasterGroup, DomainBaseEntities.DocCategory)
        && ObjectChecker.isEmptyOrNull(result['forType'])) {
        result['forType'] = this.place.quickCreateRequester;
      }
    }
    let record = result as any;
    if (result.entityType === DomainBaseEntities.DocumentTerm) {
      if (record.termConfigStr) {
        record.termConfig = JSON.parse(record.termConfigStr);
        record.termConfigStr = '';
      }
    } else if (result.entityType === DomainBaseEntities.ConfigEntry) {
      if (record.valueStr) {
        record.value = JSON.parse(record.valueStr);
        record.valueStr = '';
      }
    }
    this.clone = NamaCommon.cloneObject(result);
    this.record.value = result;
    if (await this.redirectPlaceIfDifferentEditViewOrMenu())
      return;
    if (this.afterFetchListener != null)
      this.afterFetchListener(this.record.value);
    if (this.place.focusOnField) {
      setTimeout(() => {
        new FieldToFocusUtils(this).focusFieldFromQueryParam();
      }, 250)
    }
    if (focusField)
      await FieldToFocusUtils.focusToField(new FieldToFocusUtils(this), focusField);
    if (EditViewUtils.isNew(this.place) && this.templateFieldCallerName) {
      let field = NamaCommon.getFieldValue(this.record.value, this.templateFieldCallerName);
      // TODO :: callValidate
      // callValidate(field);
      this.templateFieldCallerName = '';
      this.templateFieldCallerValue = null;
    }
    if (EditViewUtils.isNew(this.place) && this.place.fieldValues) {
      new FieldValuesSetter(this.place.fieldValues, this).start();
    }
    this.updateWindowTitle();
    // if (this.hasToolBar())
    //   toolBarPresenter.refresh();
    this.serverDependentMenuItems = await this.getServerDependantExtraMoreMenuItems();
    this.recordLoaded.value = true;
  }

  updateWindowTitle() {
    if (this.isQuickCreator())
      return;
    GUIUtilities.updateWindowTitle(this.place.getTitleForWindow());
  }

  async getServerDependantExtraMoreMenuItems(): Promise<MoreMenuItem[]> {
    let ownerId: string = this.metadata?.owner?.ownerId ?? "";
    if (EntitiesWithLedgerEffectsOrWithParents.scCostDocs.contains(ownerId)) {
      let id: string = this.record.value?.id ?? "";
      let scCriteria: DTOCriteria = CriteriaBuilder.create().field(IdsAndConstants.data_originId).equal(id).build();
      let glCriteria: DTOCriteria = this.glCriteria(id);

      let params: MatchingSimpleEntityParam[] = [{entityType: SimpleEntities.LedgerTrans, criteria: glCriteria}];
      if (ClientCache.isFifoCost()) {
        params.push({entityType: SimpleEntities.FifoCostTrans, criteria: scCriteria})
      } else {
        params.push({entityType: SimpleEntities.CostInTrans, criteria: scCriteria})
        params.push({entityType: SimpleEntities.CostOutTrans, criteria: scCriteria})
      }
      let request: AxiosRequestConfig = {data: params};
      return await this.getMoreMenuItems(request, this.metadata?.owner?.ownerId);
    } else if (EntitiesWithLedgerEffectsOrWithParents.scLedgerDocs.contains(ownerId) || FAEntities.FATransferDocument === ownerId) {
      let id: string = this.record.value?.id ?? "";
      let glCriteria: DTOCriteria = this.glCriteria(id);
      let request: AxiosRequestConfig = {data: [{entityType: SimpleEntities.LedgerTrans, criteria: glCriteria}]}
      return await this.getMoreMenuItems(request, this.metadata?.owner?.ownerId);
    }
    return [];
  }

  async getMoreMenuItems(request: NamaAxiosRequestConfig, ownerEntityType: string | undefined): Promise<MoreMenuItem[]> {
    if (!SecurityUtils.userCan(ownerEntityType, CapabilityType.CanViewTransaction)) {
      return [];
    }
    request.noLoadingIndicator = true;
    let response: DTOGui2Response | undefined = await NamaCommon.namaFetch(NamaURLS.ListSimpleEntitiesMatchingRef, request);
    let moreMenuItems: MoreMenuItem[] = [];
    if (response && NamaCommon.isSuccess(response)) {
      for (let ref of response as DTOSimpleEntityRef[]) {
        let criteria: DTOCriteria = CriteriaBuilder.create().field(CommonFieldIds.ID).equal(ref.id).build();
        moreMenuItems.push(SimpleEntityMenuItem.fromCriteria("showGeneratedSystemTransaction", ref.type!, ref.type!, criteria));
      }
    }
    return moreMenuItems;
  }

  glCriteria(id: string): DTOCriteria {
    return CriteriaBuilder.create().field(IdsAndConstants.trnsData_originId).equal(id).build();
  }

  async redirectPlaceIfDifferentEditViewOrMenu() {
    if (!ClientCache.getCustomGUISettings()?.shouldRedirectEditView)
      return false;
    let customViewName: string | undefined = this.record.value && this.record.value.customViewName ? this.record.value.customViewName : "";
    if (this.isQuickCreator() || !customViewName)
      return false;
    let parts: string[] = customViewName.split(";");
    let viewName: string = parts[0] ?? '';
    let menu: string = "";
    if (parts.length > 1)
      menu = parts[1] ?? '';
    let shouldRedirect: boolean = false;
    let newPlace: EditPlace = EditPlace.cloneFrom(this.place)
    if (viewName && ObjectChecker.areNotEqual(viewName, newPlace.calcEditViewName())) {
      shouldRedirect = true;
      if (ObjectChecker.isNotEmptyOrNull(viewName))
        newPlace.listViewName = viewName;
      if (ObjectChecker.isNotEmptyOrNull(newPlace.editViewName))
        newPlace.editViewName = viewName;
      newPlace.reNavigateToObject = this.record.value;
    }
    if (ObjectChecker.isNotEmptyOrNull(menu) && ObjectChecker.areNotEqual(menu, newPlace.src)) {
      shouldRedirect = true;
      newPlace.src = menu;
      newPlace.reNavigateToObject = this.record.value;
    }
    if (shouldRedirect) {
      await router.push({
        name: RouteNames.EDIT_VIEW_ROUTE,
        query: newPlace.fetchQuery()
      })
      return true;
    }
    return false;
  }

  calcEditModeApplicability(): string {
    if (this.isInNewMode())
      return ApplicableWhen.NewMode;
    if (this.record.value && !this.record.value.commitedBefore)
      return ApplicableWhen.DraftMode;
    return ApplicableWhen.UpdateMode;
  }

  isValidFieldForAttach(field: CompositeEditScreenField | EditScreenField | GUIActionPlaceholder): boolean {
    if (!SecurityUtils.userCanView(this.entityType, field.id!, this.calcEditModeApplicability()))
      return false;
    if (ObjectChecker.areEqual(field['namaClassTypeId'], "CompositeEditScreenField")) {
      let composite = field as CompositeEditScreenField;
      if (!composite.subFields)
        return false;
      for (let subField of composite.subFields) {
        if (this.isValidFieldForAttach(subField))
          return true;
      }
      return this.fetchFieldState(field.id!) !== WidgetState.Invisible;
    }
    let fieldMetaData: FieldMetaData | undefined = EditViewUtils.getFieldMetaData(this.metadata, field.id);
    if (!fieldMetaData && ObjectChecker.areNotEqual(CommonFieldIds.CODE, field.id)) {
      console.log("Can not find field metadata: " + field.id);
      return false;
    }
    if (fieldMetaData) {
      if (!SecurityUtils.userCanAnyFeature([fieldMetaData.relatedToFeature]))
        return false;
      if (!fieldMetaData.fieldType)
        return false;
      if (fieldMetaData.fieldType === FieldType.Reference && !this.isValidReferenceField(fieldMetaData))
        return false;
    }
    if (this.fetchFieldState(field.id!) === WidgetState.Invisible)
      return false;
    this.visibleHeaderFields.push(field);
    return true;
  }

  isValidReferenceField(fieldMetadata: FieldMetaData) {
    if (SecurityUtils.isUserLimitedToASingleLegalEntity() && DomainBaseEntities.LegalEntity === fieldMetadata.referencedEntityType)
      return false;
    if (fieldMetadata.referencedEntityType && !fieldMetadata.referencedEntityType.startsWith("$")
      && !SecurityUtils.userCanFeature(fieldMetadata.referencedEntityType))
      return false;
    return true;
  }

  isQuickCreator(): boolean {
    return this.place.quickCreate ?? false;
  }

  isHasCriteria(): boolean {
    return !!this.place.criteria;
  }

  shouldAddMainFileWidget(): boolean {
    let entityImageInfo: EntityMainFileInfo | null = ClientCache.getEntityImageInfo(this.entityType);
    return EntityTypesUtils.isMaster(this.entityType) && !!(entityImageInfo && (entityImageInfo.useInList || entityImageInfo.useInSuggestion || entityImageInfo.useInSearch ||
      entityImageInfo.useInHeaderFields || entityImageInfo.showInSeparateColumn || entityImageInfo.useInGridColumns ||
      entityImageInfo.showInPopupWithCode));
  }

  async callGUIAction(actionId: string, fromAnotherAction?: boolean) {
    if (EditViewToolbarUtils.ACTIONS.contains(actionId))
      await EditViewToolbarUtils.onToolBarButton(actionId, this);
    else
      await new ActionHandler({id: actionId} as GUIActionPlaceholder, this.metadata!, this.entityType, new EditViewPerformer(this)).performAction(fromAnotherAction);
  }

  isInNewMode(): boolean {
    return this.place.view === ViewMode.NEW;
  }

  hasChanges(fieldsToIgnore?: string[]) {
    if (!this.clone)
      return false;
    return !NamaCommon.areTwoObjectsEqual(this.record.value, this.clone, this.metadata!, fieldsToIgnore);
  }

  async confirmNavigateAway(...ignoreFields: string[]): Promise<boolean> {
    if (!this.isDirty(ignoreFields))
      return true;
    return await NaMaConfirmationDialog.okCancelConfirmationDialog(Translator.translateId('areYouToNavigate'), true);
  }

  async doSave(saveBehavior: ClassToValues<typeof SaveBehavior>, hasCallBack: boolean, fieldToFocus: string | undefined, fromAutoSave: boolean, confirmations?: DTOConfirmation[], fromRecursion?: boolean): Promise<boolean> {
    EditViewUtils.clearErrors();
    let shouldCheckCDirty: Boolean = !(this.isInNewMode() || this.isCommitDraft(saveBehavior) || !this.isVersionCurrent());
    if (shouldCheckCDirty && !this.isDirty()) {
      if (!hasCallBack)
        useMessagesStore().pushMessageStr(Translator.translateId("noChangesToSave"));
      return true;
    }
    this.clearErrors();
    let currentRecord: BaseEntityDTO | undefined = this.record.value!;
    currentRecord[CommonFieldIds.CUSTOM_VIEW_NAME] = this.place.calcEditViewName() ?? "" + ";" + (this.place.src ?? "");
    currentRecord.confirmations = confirmations;
    let record = currentRecord as any;
    if (currentRecord.entityType === DomainBaseEntities.DocumentTerm) {
      record.termConfigStr = JSON.stringify(record.termConfig);
    } else if (currentRecord.entityType === DomainBaseEntities.ConfigEntry) {
      record.valueStr = JSON.stringify(record.value);
    }
    let settings: AxiosRequestConfig = {
      params: {
        entityType: this.place.entityType,
        fromAutoSaveWithInput: fromAutoSave
      },
      data: currentRecord
    }
    let response: DTOGui2Response | undefined;
    if (saveBehavior == SaveBehavior.SaveAndCommit)
      response = await NamaCommon.namaFetch(NamaURLS.SAVE_AND_COMMIT, settings);
    // quick create must not support save draft
    else if (saveBehavior == SaveBehavior.SaveAsDraft)
      response = await NamaCommon.namaFetch(NamaURLS.SAVE_DRAFT, settings);
    this.extractAndSetErrors(response);
    if (response) {
      if (NamaCommon.isSuccess(response)) {
        await this.saveReturned(response, saveBehavior, fieldToFocus);
        return true;
      } else {
        let result: GCFailure = response as GCFailure;
        if (!fromRecursion && result && result.confirmations) {
          let confirmations: DTOConfirmation[] | undefined = await this.confirm(result.confirmations);
          if (confirmations)
            return await this.doSave(saveBehavior, hasCallBack, fieldToFocus, fromAutoSave, confirmations, true)
        }
      }
    }
    return false;
  }

  async autoSave(focusFieldAfterAutoSave: string | undefined, addLineToGridAfterAutoSave: string|undefined, saveBehaviour: ClassToValues<typeof SaveBehavior>) {
    let saveSucceeded: boolean = await this.doSave(saveBehaviour, true, focusFieldAfterAutoSave, true);
    if (!saveSucceeded)
      return;
    if (addLineToGridAfterAutoSave)
      this.appendRow(addLineToGridAfterAutoSave);
    else if (focusFieldAfterAutoSave)
      await FieldToFocusUtils.focusToField(new FieldToFocusUtils(this), focusFieldAfterAutoSave);
  }

  private extractAndSetErrors(response: namaTypes.DTOGui2Response | undefined) {
    let errors: NaMaError[] = NamaCommon.extractErrorsFromResponse(response) ?? [];
    for (let err of errors) {
      if (err.ownerId) {
        if ((err.row ?? -1) >= 0)
          this.detailErrors.value.addDetailError(err);
        else
          this.headerErrors.value.addError(err);
      }
    }
  }

  private clearErrors() {
    this.headerErrors.value = new ErrorsHolder();
    this.detailErrors.value = new ErrorsHolder();
  }

  isCommitDraft(saveBehavior: ClassToValues<typeof SaveBehavior>): boolean {
    return saveBehavior == SaveBehavior.SaveAndCommit && this.isDraftCreated(saveBehavior);
  }

  isDraftCreated(saveBehavior: ClassToValues<typeof SaveBehavior>): boolean {
    return saveBehavior == SaveBehavior.SaveAndCommit && (this.record.value?.draftCreated || false);
  }

  isVersionCurrent(): boolean {
    return !this.place.version || ObjectChecker.areEqual(this.place.version, this.record.value?.currentVersion);
  }

  get displayedVersion(): number | undefined {
    return this.place.version;
  }

  isDirty(ignoreFields?: string[]): boolean {
    if (!ignoreFields)
      ignoreFields = [];
    let allGuiFields = this.metadata ? MetaData.listAllCalculatedFields(this.metadata.fieldsMetaData) : [];
    ignoreFields = ignoreFields.concat(...allGuiFields);
    return this.hasChanges(ignoreFields) || this.isForceDirty() || this.isAnyEmbeddedEditViewsDirty();
  }

  isAnyEmbeddedEditViewsDirty(): boolean {
    if (!this.embeddedEditViewList)
      return false;
    for (let embeddedPresenter of this.embeddedEditViewList) {
      if (embeddedPresenter.isDirty())
        return true;
    }
    return false;
  }

  async saveReturned(response: DTOGui2Response, saveBehavior: SaveBehavior, fieldToFocus: string | undefined) {
    let editedType: BaseEntityDTO = response.data as BaseEntityDTO;
    const place = this.place;
    place.id = editedType.id;
    place.view = ViewMode.EDIT;
    place.version = undefined;
    await this.updateRouterFromPlaceAndSkipNextRouteRefreshAndQuickCreator();
    await this.doEdit(editedType, fieldToFocus, ViewMode.EDIT);
    useMessagesStore().pushMessageStr(Translator.translateId("recordSavedCorrectly"));
    if (response.result && response.result.warning) {
      if (response.result.errors) {
        let warnings: NamaWarning[] = response.result!.errors?.map((e) => ({...e, warning: true})) || [];
        useMessagesStore().pushMessages(warnings ?? []);
      }
    }
    if (this.record[CommonFieldIds.CURRENT_APPROVAL_CASE]) {
      await NotificationUtils.updateApprovals();
    } else if (saveBehavior == SaveBehavior.SaveAndCommit && EntityTypesUtils.isDocument(this.entityType)) {
      let book = this.record[CommonFieldIds.BOOK];
      let printOnSave: boolean = book && book[CommonFieldIds.EXTRA_DATA + "." + DomainBaseFieldIDs.DocumentBook_printOnSave];
      printOnSave = printOnSave || (LoginUtils.loginInfo?.userInfo?.settings?.printDocumentsOnSave ?? false);
      if (printOnSave) {
        if (this.record[CommonFieldIds.CURRENT_VERSION] == null || this.record[CommonFieldIds.CURRENT_VERSION] < 2)
          await this.print(OutputFormat.PDF, true)
      }
    }
    if (saveBehavior === SaveBehavior.SaveAndCommit && this.entityType === BSCEntities.TranslationOverRider) {
      await Translator.reloadTranslations();
      useMessagesStore().pushMessageStr(Translator.translateId("translationsReloaded"));
    }
  }

  async print(format: string, fromPrintButton: boolean) {
    if (this.isDirty() || this.isInNewMode()) {
      useErrorsStore().pushErrorStr(Translator.translateLayoutId("printModifiedEntity"));
      return;
    }
    let pageIndex: number = this.place.pageId ?? 0;
    const tabId = NamaPrinting.titleToParam(this.getCurrentPageTitle(), pageIndex);
    let request: PrintReportRequest = this.createPrintFormRequest(format, PrintingOption.DIALOG, this.entityType, this.record.value?.id!, tabId, this.layout?.id!, undefined, "")
    let result: boolean = await ClientCache.isPrintingPossible(request);
    if (result) {
      await NamaPrinting.printForm(this.entityType, this.record.value?.id!, this.record.value?.code!, this.getCurrentPageTitle(), format, this.layout?.id!, pageIndex,
        this.place.src ?? '', fromPrintButton);
    } else {
      useErrorsStore().pushErrorStr(Translator.translate("There is no form to print")!); // TODO :: HTML printing
    }
  }

  async emailResult() {
    let okBtn: CommonDialogAction = CommonDialogAction.createOkDialogAction(async (emailInfo: Record<string, any>) => {
      if (this.isDirty() || this.isInNewMode()) {
        useErrorsStore().pushErrorStr(Translator.translate("printModifiedEntity")!);
        return;
      }
      if (!emailInfo)
        return;
      let format = emailInfo.outputFormat;
      let request: PrintReportRequest = {
        printingOption: PrintingOption.DIALOG,
        format: format,
        entityType: this.entityType,
        entityId: this.record.value?.id,
        tabId: NamaPrinting.titleToParam(this.getCurrentPageTitle(), this.place.pageId ?? 0),
        form: true,
        formReportId: ''
      }
      let result: boolean | undefined = await ClientCache.isPrintingPossible(request);
      if (!result)
        return;
      await EditPresenter.sendEmail(emailInfo, format, this.entityType, this.record.value?.id, NamaPrinting.titleToParam(this.getCurrentPageTitle(), this.place.pageId ?? 0),
        this.layout?.id, this.place?.src, true)
    });
    let cancelBtn: CommonDialogAction = CommonDialogAction.createCancelDialogAction(() => {
    });
    let questionFields: QuestionField[] = [];
    ReportViewerPresenter.addEmailSendDialogFields(questionFields, EmailSenderDialogType.SendForm);
    let defaultValues: DTOFilledQuestionField[] = [
      {id: IdsAndConstants.outputFormat, value: RepOutputFormat.PDF, objValue: RepOutputFormat.PDF}
    ];
    let dialogBox = new DialogHandler([okBtn, cancelBtn], Translator.translateId("emailSend"), false);
    await dialogBox.createPresenter(this, questionFields, defaultValues);
    await dialogBox.runDialogBox();
  }

  static async sendEmail(emailInfo: Record<string, any>, format: string, entityType: string, id: string | undefined, pageTitle: string | undefined, layoutId: string | undefined, src: string | undefined, isForm: boolean) {
    let request: LaunchReportRequest = {
      questions: "",
      reportId: "",
      outputFormat: format,
      printingOption: NamaPrinting.getDirectPrintOption(),
      downloadPurpose: DownloadPurpose.PRINT,
      entityType: entityType,
      entityId: id,
      tabId: pageTitle,
      viewName: layoutId,
      isForm: isForm,
      menuCode: src
    };
    NamaCommon.addCommonParametersToRequest(request);
    let settings: AxiosRequestConfig = {
      data: request
    }
    let response = await NamaCommon.namaFetch(NamaURLS.RunReport, settings);
    if (response && response.result && response.result.succeded) {
      let printingParams: PrintingParams[] = response.list;
      let tempPrintIds: (string | undefined)[] = printingParams.map(l => l.tempPrintId);
      if (tempPrintIds && tempPrintIds[0]) {
        emailInfo.temPrintId = tempPrintIds[0];
        let request: DTOEmailSendRequest = emailInfo as DTOEmailSendRequest;
        let settings: AxiosRequestConfig = {
          data: request
        };
        let response = await NamaCommon.namaFetch(NamaURLS.SendEmailWithResult, settings);
        if (response && NamaCommon.isSuccess(response))
          useMessagesStore().pushMessageStr(Translator.translateId('sendIsScheduled'));
      }
    }
  }

  async duplicate() {
    if (!await this.confirmNavigateAway())
      return
    let record: BaseEntityDTO = this.record.value!;
    let request: AxiosRequestConfig = {
      params: {
        entityType: this.entityType, id: record.id
      }
    };
    let response: DTOGui2Response | undefined = await NamaCommon.namaFetch(NamaURLS.DUPLICATE, request);
    if (response && NamaCommon.isSuccess(response)) {
      let editModeToUse: string = ViewMode.NEW;
      let place: EditPlace = this.place;
      place.id = undefined;
      place.code = undefined;
      place.view = editModeToUse;
      await this.doEdit(response.data as BaseEntityDTO, "", editModeToUse);
      this.updateWindowTitle();
      await this.updateRouterFromPlaceAndSkipNextRouteRefreshAndQuickCreator();
    }
  }

  getCurrentPageTitle(): NaMaText {
    let indexInLayout: number = this.place.pageId ?? 0;
    if (this.pages.value[indexInLayout] && this.pages.value[indexInLayout].title)
      return this.pages.value[indexInLayout].title;
    return {};
  }

  createPrintFormRequest(outputFormat: string, printingOption: string, entityType: string, entityId: string, tabId: string, viewName: string, monitorId: string | undefined, formReportId: string): PrintReportRequest {
    return {
      printingOption: printingOption,
      format: outputFormat,
      entityType: entityType,
      entityId: entityId,
      tabId: tabId,
      viewName: viewName,
      form: true,
      monitorId: monitorId,
      formReportId: formReportId
    };
  }

  async startDelete(id: string | undefined, code: string | undefined) {
    let response: DTOGui2Response | undefined = await this._navigate(NavigationType.Next);
    if (response && !response.data) {
      response = await this._navigate(NavigationType.Previous);
      if (response) {
        this.afterDeleteRecord = response;
        await this.doDelete(id, code);
      }
    } else {
      this.afterDeleteRecord = response;
      await this.doDelete(id, code);
    }
  }

  async doDelete(id: string | undefined, code: string | undefined, confirmation?: DTOConfirmation[], fromRecursion?: boolean) {
    let navigateRequest: NavigationRequest = this.createCurrentRecordInfo(NavigationType.Next).data
    navigateRequest.confirmations = confirmation;
    let request: AxiosRequestConfig = {
      params: {
        entityType: this.entityType, id: id, code: code
      },
      data: navigateRequest
    };
    let response: DTOGui2Response | undefined = await NamaCommon.namaFetch(NamaURLS.DELETE, request);
    if (!response) {
      await this.onGoToListView();
      return;
    }
    if (NamaCommon.isSuccess(response)) {
      if (response[CommonFieldIds.DOCUMENT_FILE_STATUS] === DocumentFileStatus.ApprovalPending) {
        await this.refresh(false, true);
        return;
      }
      if (this.afterDeleteRecord && this.afterDeleteRecord.data) {
        await this.navigationReturned(this.afterDeleteRecord.data)
        //TODO::view.deleted(id)
      } else {
        await this.onGoToListView()
      }
      useMessagesStore().pushMessageStr(Translator.translateId("recordDeletedCorrectly"));
      this.afterDeleteRecord = null;
    } else {
      let result: GCFailure = response;
      if (!fromRecursion && result && result.confirmations) {
        let confirmations: DTOConfirmation[] | undefined = await this.confirm(result.confirmations);
        if (confirmations)
          await this.doDelete(id, code, confirmations, true);
      }
    }
  }

  async confirm(confirmations: DTOConfirmation[]) {
    for (let confirmation of confirmations) {
      let isYes: boolean = await NaMaConfirmationDialog.yesNoConfirmationDialog(Translator.translateNaMaText(confirmation.message), true, Translator.translateId('confirmBeforeStarting'))
      if (isYes)
        confirmation.confirmed = true;
    }
    return confirmations;
  }

  async onGoToListView() {
    let listPlace = new ListPlace(this.place.fetchQuery());
    let query = listPlace.fetchQuery();
    await router.push({
      name: RouteNames.LIST_VIEW_ROUTE,
      query: query
    })
    try{
      if (this.closeQuickEditDialog)
        this.closeQuickEditDialog();
    }catch{

    }
  }

  async refresh(doNotHideErrors: boolean, doNotHideWarnings: boolean) {
    this.doNotHideErrors = doNotHideErrors;
    this.doNotHideWarnings = doNotHideWarnings;
    this.createdObject = undefined;
    if (await this.edit(true))
      await this.refreshAndHideAllEmbeddedEditViews();
  }

  async refreshAndHideAllEmbeddedEditViews() {
    if (!this.embeddedEditViewList)
      return;
    for (let embeddedPresenter of this.embeddedEditViewList) {
      if (embeddedPresenter.editScreenEmbeddedEditView && embeddedPresenter.editScreenEmbeddedEditView.handleHide) {
        await embeddedPresenter.edit(false);
        embeddedPresenter.editScreenEmbeddedEditView.handleHide();
      }
    }
  }

  async onNew(templateId?: string, fromApplyTemplate?: boolean) {
    if (!fromApplyTemplate && !await this.confirmNavigateAway())
      return;
    if (!templateId) {
      let line: DTOMenuItem | null = ClientCache.getMenuLineBySrc(this.place.src);
      if (line && line.target?.defaultsTemplate)
        templateId = line.target.defaultsTemplate.id;
    }
    const place = this.place;
    place.id = undefined;
    place.code = undefined;
    place.view = ViewMode.NEW;
    place.templateId = templateId;
    place.fieldValues = undefined;
    this.createdObject = undefined;
    await this.updateRouterFromPlaceAndSkipNextRouteRefreshAndQuickCreator()
    await this.edit(false);
  }

  async updateRouterFromPlaceAndSkipNextRouteRefreshAndQuickCreator() {
    if (this.isQuickCreator())
      return;
    this.skipNextRouteRefresh = true;
    await router.push({
      name: RouteNames.EDIT_VIEW_ROUTE,
      query: this.place.fetchQuery(),
    });
    this.skipNextRouteRefresh = false;
  }

  async markRevised(revised: boolean) {
    if (this.isDirty() || this.isInNewMode()) {
      useErrorsStore().pushErrorStr(Translator.translateLayoutId("actionModifiedEntity"));
      return;
    }
    let record = this.record.value!;
    let request: AxiosRequestConfig = {
      params: {
        entityType: record.entityType, id: record.id, revise: revised
      }
    };
    let response: DTOGui2Response | undefined = await NamaCommon.namaFetch(NamaURLS.REVISE, request);
    if (response && NamaCommon.isSuccess(response)) {
      await this.refresh(true, true);
    }
  }

  async navigate(navigationType: string) {
    if (!await this.confirmNavigateAway())
      return;
    let response: DTOGui2Response | undefined = await this._navigate(navigationType);
    if (response && response.result && !response.result.failureOccurred)
      await this.navigationReturned(response.data);
  }

  async removeFilter() {
    this.place.criteria = '';
    ClientCache.uiPreferencesCache[this.entityType] = {};
    await this.updateRouterFromPlaceAndSkipNextRouteRefreshAndQuickCreator();
    await this.refresh(true, true);
  }

  async updateRecordWhenCodeChanged(fieldId: string, value: BaseEntityDTO) {
    if (!await this.confirmNavigateAway(fieldId))
      return;
    await this.navigationReturned(value);
  }

  async goToEntityFromField(fieldId: string, value: EntityReferenceData) {
    if (!await this.confirmNavigateAway(fieldId))
      return;
    let place = this.place;
    place.id = value.id;
    place.version = undefined;
    if (place.view === ViewMode.NEW)
      place.view = ViewMode.EDIT;
    await this.updateRouterFromPlaceAndSkipNextRouteRefreshAndQuickCreator()
    await this.edit(false);
  }

  private async _navigate(navigationType: string) {
    let request: AxiosRequestConfig = this.createCurrentRecordInfo(navigationType);
    let response: DTOGui2Response | undefined = await NamaCommon.namaFetch(NamaURLS.NAVIGATE, request);
    return response;
  }

  async navigationReturned(result: BaseEntityDTO | any) {
    if (!result)
      return;
    let editModeToUse: string = this.isInNewMode() || this.place.view == null ? ViewMode.EDIT : this.place.view;
    let place: EditPlace = this.place;
    place.id = result.id;
    place.view = editModeToUse;
    place.version = undefined;
    await this.doEdit(result, "", editModeToUse);
    this.updateWindowTitle();
    this.updateSelectedNodeId(place.id);
    await this.updateRouterFromPlaceAndSkipNextRouteRefreshAndQuickCreator();
  }

  createCurrentRecordInfo(navigationType: string): AxiosRequestConfig {
    const quickFilters = this.place.quickFilters
    const selectedQuickFilterGroups = QuickFilterUtils.deserializeFromURL(quickFilters)
    const req: NavigationRequest = {
      id: this.place.id || this.record.value?.id,
      orderBy: this.getOrderBy() ?? "code",
      criteria: this.getCriteria(),
      menuItemExtraCriteriaId: EditPresenter.getMenuViewExtraCriteriaId(this.place.src),
      questionFields: this.getQuestionFields(),
      entityType: this.entityType,
      listId: this.place.listViewName,
      owner: {ownerId: this.entityType},
      ascending: this.place.ascending,
      navigationType: navigationType,
      extraCriteriaId: this.place.extraCriteria,
      selectedQuickFilterGroups
    };
    return {
      params: {
        entityType: this.place.entityType,
        type: navigationType
      },
      data: req
    };
  }

  fetchExtraCriteriaIdFromPlace(): string | undefined {
    return EditPresenter.getMenuViewExtraCriteriaId(this.place.src);
  }

  fetchParentFieldTitle(): string {
    return this.parentFieldTitle;
  }

  fetchCriteriaFromPlace(): DTOCriteria | undefined {
    return this.getCriteria();
  }

  isEditPresenter(): this is EditPresenter {
    return true;
  }

  doesFieldHasSuggestionProvider(fieldMetaData: FieldMetaData): boolean {
    if (!fieldMetaData.fieldInformation)
      return false;
    let fieldStyle = ClientCache.getFieldStyle(this.entityType, fieldMetaData.fieldId!);
    if (fieldStyle && fieldStyle.disableSuggestionProvider)
      return false;
    if (fieldMetaData.fieldInformation.hasSuggestionProvider)
      return true;
    let suggestionProviders = ClientCache.getCustomGUISettings()?.tooltipsAndReportsAndRevise?.suggestionProviders;
    return !!(suggestionProviders && suggestionProviders[this.entityType + "." + fieldMetaData.fieldId!]);
  }

  getOrderBy(): string | undefined {
    if (!this.place.orderBy)
      return CacheUtil.getCachedOrderBy(this.entityType, this.place.listViewName);
    else
      return this.place.orderBy;
  }

  getQuestionFields(): DTOFilledQuestionField[] {
    if (!this.place.questions)
      return CacheUtil.getCachedQuestionFields(this.entityType, this.place.listViewName);
    else
      return new QuestionFieldsSerializer().questionsFromURL(this.place.questions);
  }

  getCriteria(): DTOCriteria | undefined {
    let listViewCriteria: DTOCriteria | undefined = this.getListViewCriteria();
    return listViewCriteria;
  }

  getListViewCriteria(): DTOCriteria | undefined {
    return ListViewUtils.getListViewCriteria(this.place);
  }

  static getMenuViewExtraCriteriaId(src: string | undefined): string | undefined {
    let line: DTOMenuItem | undefined = EditPresenter.getMenuLineBySrc(src);
    return line && line.target && line.target.criteria ? line.target.criteria.id : undefined;
  }

  static getMenuLineBySrc(src: string | undefined): DTOMenuItem | undefined {
    if (!src)
      return undefined;
    let menu: DTOMenuDefinition | undefined = LoginUtils.loginInfo?.menu;
    return menu?.items?.find((line, i, obj) => ObjectChecker.isAnyEqualToFirst(src, line.id, line.code));
  }

  getPlaceExtraFieldFilterId() {
    if (this.isQuickCreator())
      return undefined;
    let line = ClientCache.getMenuLineBySrc(this.place.src);
    if (line && line.target && line.target.extraFieldFilter)
      return line.target.extraFieldFilter.id;
    return undefined;
  }

  canBeRevised() {
    let revisedLevel: number = EditViewUtils.currentReviseLevelInt(this.record.value);
    let toBeRevisedCount: number | undefined = ClientCache.findEntityMaxReviseCount(this.entityType).reviseLevel;
    if (toBeRevisedCount && revisedLevel < toBeRevisedCount)
      return true;
    return false;
  }

  canBeUnRevised() {
    let revisedCount: number = EditViewUtils.currentReviseLevelInt(this.record.value);
    if (revisedCount > 0)
      return true;
    return false;
  }

  async onCustomActionSuccess(result: GUIActionResult): Promise<void> {
    await ActionPerformerUtil.processGUIActionResult(result, -1, this.dispatcher!);
    await this.refresh(true, true);
  }

  capFilledQuestion(capabilityId: string) {
    let filledQuestion: DTOFilledQuestionField = {
      id: capabilityId,
      objValue: NamaCommon.getFieldValue(this.record.value, capabilityId)
    };
    if (filledQuestion.objValue)
      filledQuestion.value = filledQuestion.objValue['id'] + CommonConstants.FIELD_PARTS_SEP + filledQuestion.objValue['entityType'] +
        CommonConstants.FIELD_PARTS_SEP + filledQuestion.objValue['code'] + CommonConstants.FIELD_PARTS_SEP + filledQuestion.objValue['actualCode']
        + CommonConstants.FIELD_PARTS_SEP + filledQuestion.objValue['name1'] + CommonConstants.FIELD_PARTS_SEP + filledQuestion.objValue['name2'];
    return filledQuestion;
  }

  showErrorsExecuteFn() {
    useToastManager().showErrorsToast();
  };
  printBarcodeExecuteFn = async () => {
    if (!this.isDirty()) {
      useMessagesStore().pushMessageStr(Translator.translateId("actionModifiedEntity"));
    } else {
      let ids: string[] = this.record.value?.id ? [this.record.value?.id] : [];
      await GUIUtilities.printBarcode(this.entityType, ids);
    }
  };

  changeCapabilitiesExecuteFn = async () => {
    if (this.hasChanges()) {
      useMessagesStore().pushMessageStr(Translator.translateId("actionModifiedEntity"));
      return;
    }

    let questionFields: QuestionField[] = [];
    questionFields.push(NamaCommon.createQuestionFieldRef(CommonFieldIds.VIEW_CAPABILITY, BSCEntities.SecurityCapability));
    questionFields.push(NamaCommon.createQuestionFieldRef(CommonFieldIds.UPDATE_CAPABILITY, BSCEntities.SecurityCapability));
    questionFields.push(NamaCommon.createQuestionFieldRef(CommonFieldIds.USAGE_CAPABILITY, BSCEntities.SecurityCapability));

    let filledQuestions: DTOFilledQuestionField[] = [];
    filledQuestions.push(this.capFilledQuestion(CommonFieldIds.VIEW_CAPABILITY));
    filledQuestions.push(this.capFilledQuestion(CommonFieldIds.UPDATE_CAPABILITY));
    filledQuestions.push(this.capFilledQuestion(CommonFieldIds.USAGE_CAPABILITY));

    let questionFieldsPresenter: QuestionFieldsPresenter = new QuestionFieldsPresenter('');
    questionFieldsPresenter.performer = new EditViewPerformer(this);
    await questionFieldsPresenter.edit(questionFields, filledQuestions);
    let okBtn: CommonDialogAction = CommonDialogAction.createOkDialogAction(async (record: Record<string, any>) => {
      let object = this.record.value!;
      let viewCapability: DTOFilledQuestionField | undefined = record[CommonFieldIds.VIEW_CAPABILITY]
      let updateCapability: DTOFilledQuestionField | undefined = record[CommonFieldIds.UPDATE_CAPABILITY]
      let usageCapability: DTOFilledQuestionField | undefined = record[CommonFieldIds.USAGE_CAPABILITY]
      let request: ChangeCapabilitiesRequest = {
        id: object.id,
        entityType: object.entityType,
        viewCapability: viewCapability ? viewCapability['id'] : '',
        updateCapability: updateCapability ? updateCapability['id'] : '',
        usageCapability: usageCapability ? usageCapability['id'] : ''
      }
      let settings: NamaAxiosRequestConfig = {
        data: request
      };
      let response: DTOGui2Response | undefined = await NamaCommon.namaFetch(NamaURLS.Change_Capabilities, settings);
      if (response && NamaCommon.isSuccess(response)) {
        useMessagesStore().pushMessageStr(Translator.translateId("recordSavedCorrectly"));
        await this.edit(false);
      }
    });
    let cancelBtn: CommonDialogAction = CommonDialogAction.createCancelDialogAction(() => {
    });
    let dialogBox: DialogHandler = new DialogHandler([okBtn, cancelBtn], Translator.translateId('changeCapabilities'));
    await dialogBox.createPresenter(questionFieldsPresenter as WidgetsPresenter);
    await dialogBox.runDialogBox();
  };
  allowUsageExecuteFn = () => {
    if (this.record.value)
      this.record.value.preventUsage = false;
  };
  preventUsageExecuteFn = () => {
    if (this.record.value)
      this.record.value.preventUsage = true;
  };
  allowUsageAsFromDocExecuteFn = () => {
    if (this.record.value)
      this.record.value[CommonFieldIds.PREVENT_USE_AS_FROMDOC] = false;
  };
  preventUsageAsFromDocExecuteFn = () => {
    if (this.record.value)
      this.record.value[CommonFieldIds.PREVENT_USE_AS_FROMDOC] = true;
  };

  preValidateCreateNewRecord(): boolean {
    if (this.isViewOnlyModeInEmbeddedEdit())
      return false;
    if (SecurityUtils.userCanEdit(this.entityType))
      return true;
    return SecurityUtils.userCanCreate(this.entityType);
  }

  preValidateSaveAndContinue(): boolean {
    return this.preValidateSave() && this.preValidateCreateNewRecord();
  }

  preValidateSave(): boolean {
    if (this.dispatcher?.userCanNotEdit())
      return false;
    return this.preValidateEditedObjectRelatedButton();
  }

  private preValidateEditedObjectRelatedButton(): boolean {
    return !this.record.value ? false : this.defaultToolBarButtonState();
  }

  defaultToolBarButtonState(): boolean {
    return !this.dispatcher?.isViewOnlyMode();
  }

  isViewOnlyModeInEmbeddedEdit() {
    if (this.editScreenEmbeddedEditView && this.editScreenEmbeddedEditView.block.viewOnly)
      return true;
    return false;
  }

  preValidateSaveDraft(): boolean {
    if (this.dispatcher?.isViewOnlyMode())
      return false;
    if (EntityTypesUtils.isDocument(this.entityType) && this.fetchRecord().commitedBefore)
      return false;
    if (SecurityUtils.userCanEdit(this.entityType))
      return true;
    return SecurityUtils.userCan(this.entityType, CapabilityType.SaveDraft);
  }

  canDuplicate(): boolean {
    if (this.isViewOnlyModeInEmbeddedEdit())
      return false;
    return !this.isInNewMode() && SecurityUtils.userCan(this.entityType, CapabilityType.Duplicate) && this.fetchRecord()?.generationType !== GenerationType.GeneratedFinal;
  }

  preValidateRefresh(): boolean {
    return true;
  }

  preValidatePrint(): boolean {
    return this.defaultToolBarNavigationButtonState();
  }

  private defaultToolBarNavigationButtonState(): boolean {
    return true;
  }

  preValidateGoToListView(): boolean {
    if (!SecurityUtils.userCan(this.entityType, CapabilityType.ListView))
      return false;
    return this.defaultToolBarNavigationButtonState();
  }

  preValidateGoToFirstRecord(): boolean {
    if (!SecurityUtils.userCan(this.entityType, CapabilityType.RecordView))
      return false;
    return this.defaultToolBarNavigationButtonState();
  }

  preValidateGoToPreviousRecord(): boolean {
    if (!SecurityUtils.userCan(this.entityType, CapabilityType.RecordView))
      return false;
    return this.defaultToolBarNavigationButtonState();
  }

  preValidateGoToNextRecord(): boolean {
    if (!SecurityUtils.userCan(this.entityType, CapabilityType.RecordView))
      return false;
    return this.defaultToolBarNavigationButtonState();
  }

  preValidateGoToLastRecord(): boolean {
    if (!SecurityUtils.userCan(this.entityType, CapabilityType.RecordView))
      return false;
    return this.defaultToolBarNavigationButtonState();
  }

  preValidateDelete(): boolean {
    if (this.dispatcher?.isNotEditableBySystem() || this.isInNewMode())
      return false;
    if (!this.fetchRecord()?.commitedBefore)
      return SecurityUtils.userCanDeleteDraft(this.entityType);
    return SecurityUtils.userCanDelete(this.entityType);
  }

  preValidateApproval(): boolean {
    if (!SecurityUtils.userCanApprove(this.entityType))
      return false;
    if (!this.dispatcher?.isApprovalPending())
      return false;
    return this.isUserEmployeeCandidate();
  }

  private isUserEmployeeCandidate(): boolean {
    let currentCandidates: string | undefined = this.fetchRecord().currentApprovalCase.currentCandidates;
    let currentUserEmployeeId: string | undefined = LoginUtils.currentUserEmployeeId()
    if (currentCandidates && currentUserEmployeeId && currentCandidates.includes(currentUserEmployeeId))
      return true;
    return false
  }

  preValidateRevise(): boolean {
    if (!this.fetchRecord()?.commitedBefore)
      return false;
    return SecurityUtils.userCan(this.entityType, CapabilityType.Revise + EditViewUtils.toReviseLevel(EditViewUtils.currentReviseLevelInt(this.fetchRecord()) + 1));
  }

  preValidateUnRevise(): boolean {
    return SecurityUtils.userCan(this.entityType, CapabilityType.Unrevise + EditViewUtils.currentReviseLevelInt(this.fetchRecord()));
  }

  preValidateTreeView(): boolean {
    return this.supportsTreeViewInEditView();
  }

  private supportsTreeViewInEditView(): boolean {
    if (NamaCommon.hasParentEntity(this.entityType))
      return true;
    return false;
  }

  onVueUnmounted() {
    this.watchers.forEach(w => w());
  }

  fetchFieldState(fieldId: string): string | undefined | null {
    if (!this.record.value)
      return undefined;
    if (this.dispatcher?.isApprovalPending() && this.approvalEditableFields.value && this.approvalEditableFields.value.length && !this.approvalEditableFields.value.contains(fieldId))
      return WidgetState.Disabled;
    if (!this.record.value.prevalidationResult || !this.record.value.prevalidationResult.header)
      return undefined;
    return this.record.value.prevalidationResult.header[fieldId];
  }

  fetchColumnState(rowId: string, parentDetailId: string, columnId: string): string | undefined | null {
    let record = this.record.value;
    if (!record)
      return;
    let defaultState = record.vueReadOnly ? WidgetState.Disabled : undefined;
    if (this.dispatcher?.isApprovalPending() && this.approvalEditableFields.value && this.approvalEditableFields.value.length && !this.approvalEditableFields.value.contains(columnId))
      return WidgetState.Disabled;
    if (!record.prevalidationResult)
      return defaultState;
    if (record.prevalidationResult.header && record.prevalidationResult.header[parentDetailId] === WidgetState.Disabled)
      defaultState = WidgetState.Disabled;
    if (!record.prevalidationResult.details)
      return defaultState;
    let gridState = record.prevalidationResult.details[parentDetailId];
    if (!gridState)
      return defaultState;
    let rowState = gridState[rowId];
    if (!rowState)
      return defaultState;
    if (rowState[columnId] === WidgetState.Invisible)
      return WidgetState.Invisible;
    return rowState[columnId] || defaultState;
  }

  isFieldDisabled(fieldId: string): boolean {
    return this.dispatcher?.isViewOnlyMode() || this.fetchFieldState(fieldId) === WidgetState.Disabled
      || !SecurityUtils.userCanEdit(this.entityType, fieldId, this.calcEditModeApplicability());
  }

  static getBaseDisabledFields(): string[] {
    return ["details.item.item"];
  }

  isColumnDisabled(rowId: string, parentDetailId: string, columnId: string): boolean {
    const viewOnlyMode = this.dispatcher?.isViewOnlyMode();
    const columnStateIsDisabled = this.fetchColumnState(rowId, parentDetailId, columnId) === WidgetState.Disabled;
    const userCanEdit = SecurityUtils.userCanEdit(this.entityType, columnId, this.calcEditModeApplicability());
    const isSystemFields = Boolean(MetaData.findFieldMetadata(columnId, this.fetchMetadata())?.systemField);
    return viewOnlyMode || columnStateIsDisabled || !userCanEdit || isSystemFields;
  }

  isFieldHidden(field: string): boolean {
    return this.fetchFieldState(field) === WidgetState.Invisible;
  }

  updateHeaderFieldStatus(fieldId: string, state: string | undefined) {
    if (!this.record.value)
      return;
    if (!this.record.value.prevalidationResult)
      this.record.value.prevalidationResult = {};
    if (!this.record.value.prevalidationResult.header)
      this.record.value.prevalidationResult.header = {};
    this.record.value.prevalidationResult.header[fieldId] = state;
  }

  prependPage(page: EditScreenPage) {
    this.pages.value.unshift(page);
    return this;
  }

  updateColumnStatus(columnId: string, parentDetail: string, state: string | undefined, rowIndex: number) {
    if (!this.record.value)
      return;
    if (!this.record.value.prevalidationResult)
      this.record.value.prevalidationResult = {};
    if (!this.record.value.prevalidationResult.details)
      this.record.value.prevalidationResult.details = {};
    if (!this.record.value.prevalidationResult.details[parentDetail])
      this.record.value.prevalidationResult.details[parentDetail] = {};
    let rowId = NamaCommon.getFieldValue(this.record.value, parentDetail + ".id", rowIndex);
    if (!rowId)
      return;
    if (!this.record.value.prevalidationResult.details[parentDetail][rowId])
      this.record.value.prevalidationResult.details[parentDetail][rowId] = {};
    this.record.value.prevalidationResult.details[parentDetail][rowId][columnId] = state;
  }

  fetchCriteriaFromFilterField(filteredType?: string): namaTypes.DTOCriteria | undefined {
    return;
  }

  getEditViewTitle(): ComputedRef<string> {
    return computed(() => {
      const object = this.fetchRecord();
      if (!object)
        return "...";
      if (EditViewUtils.isNew(this.place))
        return Translator.translateId('addNew') + " " + Translator.getDetailsViewTitlePrefix(this.place.entityType, ClientCache.getMenuLineBySrc(this.place.src))
      let description: string = EditViewUtils.getEditViewTitle(this.place, object);
      let title: string | undefined = Translator.getName(object.arabicTitle, object.englishTitle);
      if (title)
        description += ' (' + title + ')';
      return description;
    })
  }
}

export interface IEditView {
  hideToolbar(): void;

  editObject(object: BaseEntityDTO): void;
}

class ErrorsHolder {
  addError(err: NaMaError) {
    let str: string | undefined = Translator.translateNaMaText(err.message);
    if (this[err.ownerId ?? ""])
      str = this[err.ownerId ?? ""] + "\n" + str;
    this[err.ownerId ?? ""] = str;
  }

  addDetailError(err: NaMaError) {
    let str: string | undefined = Translator.translateNaMaText(err.message);
    if (this[err.ownerId ?? ""])
      str = this[err.ownerId ?? ""] + "\n" + str;
    this[err.ownerId ?? ""] = str;
  }
}
